export const fuels = [
  {
    title: "Diesel",
    value: 1
  },
  {
    title: "Benzin",
    value: 2
  },
  {
    title: "Hibridni",
    value: 3
  },
  {
    title: "Benzin + LPG",
    value: 4
  },
  {
    title: "Električni",
    value: 5
  }
];

export const landTypes = [
  {
    title: "Građevinsko",
    value: 1
  },
  {
    title: "Poljoprivredno",
    value: 2
  }
];

export const realEstateType = [
  {
    title: "Stan",
    value: "flats-for-sale",
    valueHr: "prodaja-stanova",
    rooms: [
      {
        title: "Garsonijera",
        value: 0
      },
      {
        title: "1-sobni",
        value: 1
      },
      {
        title: "2-sobni",
        value: 2
      },
      {
        title: "3-sobni",
        value: 3
      },
      {
        title: "4-sobni",
        value: 4
      },
      {
        title: "5+ sobni",
        value: 5
      }
    ]
  },
  {
    title: "Stan",
    value: "flats-for-rent",
    valueHr: "najam-stanova",
    rooms: [
      {
        title: "Garsonijera",
        value: 0
      },
      {
        title: "1-sobni",
        value: 1
      },
      {
        title: "2-sobni",
        value: 2
      },
      {
        title: "3-sobni",
        value: 3
      },
      {
        title: "4-sobni",
        value: 4
      },
      {
        title: "5+ sobni",
        value: 5
      }
    ]
  },
  {
    title: "Kuća",
    value: "houses-for-sale",
    valueHr: "prodaja-kuca",
    rooms: [
      {
        title: "1-sobna",
        value: 1
      },
      {
        title: "2-sobna",
        value: 2
      },
      {
        title: "3-sobna",
        value: 3
      },
      {
        title: "4-sobna",
        value: 4
      },
      {
        title: "5-sobna",
        value: 5
      },
      {
        title: "6-sobna",
        value: 6
      },
      {
        title: "7-sobna",
        value: 7
      },
      {
        title: "8-sobna",
        value: 8
      },
      {
        title: "9-sobna",
        value: 9
      },
      {
        title: "10-sobna",
        value: 10
      },
      {
        title: "11-sobna",
        value: 11
      },
      {
        title: "12-sobna",
        value: 12
      },
      {
        title: "13-sobna",
        value: 13
      },
      {
        title: "14-sobna",
        value: 14
      },
      {
        title: "15-sobna",
        value: 15
      },
      {
        title: "16-sobna",
        value: 16
      },
      {
        title: "17-sobna",
        value: 17
      },
      {
        title: "18-sobna",
        value: 18
      },
      {
        title: "19-sobna",
        value: 19
      },
      {
        title: "20-sobna",
        value: 20
      }
    ]
  },
  {
    title: "Kuća",
    value: "houses-for-rent",
    valueHr: "najam-kuca",
    rooms: [
      {
        title: "1-sobna",
        value: 1
      },
      {
        title: "2-sobna",
        value: 2
      },
      {
        title: "3-sobna",
        value: 3
      },
      {
        title: "4-sobna",
        value: 4
      },
      {
        title: "5-sobna",
        value: 5
      },
      {
        title: "6-sobna",
        value: 6
      },
      {
        title: "7-sobna",
        value: 7
      },
      {
        title: "8-sobna",
        value: 8
      },
      {
        title: "9-sobna",
        value: 9
      },
      {
        title: "10-sobna",
        value: 10
      },
      {
        title: "11-sobna",
        value: 11
      },
      {
        title: "12-sobna",
        value: 12
      },
      {
        title: "13-sobna",
        value: 13
      },
      {
        title: "14-sobna",
        value: 14
      },
      {
        title: "15-sobna",
        value: 15
      },
      {
        title: "16-sobna",
        value: 16
      },
      {
        title: "17-sobna",
        value: 17
      },
      {
        title: "18-sobna",
        value: 18
      },
      {
        title: "19-sobna",
        value: 19
      },
      {
        title: "20-sobna",
        value: 20
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/FormControls/SuggestedTitle/helpers.ts